export default __webpack_public_path__ + "static/media/chivo-regular.4306fdbd.woff2";